var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { StyleSheet, css } from 'aphrodite';
import { Flex, Box } from '../../CommonUI/Layout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
var Input = (function (_super) {
    __extends(Input, _super);
    function Input(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { focused: false, showPassword: false };
        _this.onEnterPress = _this.onEnterPress.bind(_this);
        _this.onBlur = _this.onBlur.bind(_this);
        _this.onFocus = _this.onFocus.bind(_this);
        _this.onShowPassword = _this.onShowPassword.bind(_this);
        return _this;
    }
    Input.prototype.onEnterPress = function (event) {
        if (this.props.onEnterPress && event.key === 'Enter') {
            this.props.onEnterPress(event);
        }
    };
    Input.prototype.onFocus = function () {
        this.setState({ focused: true });
    };
    Input.prototype.onBlur = function () {
        var _this = this;
        this.setState({ focused: false }, function () {
            var validate = _this.props.validate;
            if (validate) {
                validate(_this.props.value);
            }
        });
    };
    Input.prototype.onShowPassword = function () {
        var showPassword = this.state.showPassword;
        this.setState({ showPassword: !showPassword });
    };
    Input.prototype.onMouseDown = function (event) {
        event.preventDefault();
    };
    Input.prototype.render = function () {
        var _a = this.props, id = _a.id, label = _a.label, type = _a.type, value = _a.value, disabled = _a.disabled, errorMessage = _a.errorMessage, onChange = _a.onChange, maxLength = _a.maxLength;
        var _b = this.state, focused = _b.focused, showPassword = _b.showPassword;
        return (React.createElement(Box, null,
            React.createElement(Flex, null,
                React.createElement(Box, { width: "100%", mt: "0px" },
                    React.createElement(Flex, { flexDirection: "row", alignItems: "flex-start", justifyContent: "start" },
                        React.createElement("div", { className: css(styles.inputPlaceholderWrapper) },
                            type === 'password'
                                ? (React.createElement("span", { className: css(styles.showPassword), onClick: this.onShowPassword, onMouseDown: this.onMouseDown }, showPassword
                                    ? React.createElement(FontAwesomeIcon, { icon: faEyeSlash })
                                    : React.createElement("span", { className: css(styles.eye) },
                                        React.createElement(FontAwesomeIcon, { icon: faEye }))))
                                : undefined,
                            React.createElement("input", { id: id || '', type: (type === 'password' && showPassword ? 'text' : type) || 'text', value: (value === undefined || value === null) ? '' : value, disabled: disabled, className: css(styles.text, styles.textPseudo), onChange: onChange, onKeyPress: this.onEnterPress, onFocus: this.onFocus, onBlur: this.onBlur, maxLength: maxLength }),
                            React.createElement("span", { className: css(styles.inputPlaceholder, (focused || !!value || errorMessage) && styles.inputPlaceholderFocused, errorMessage && styles.inputPlaceholderError) }, errorMessage ? errorMessage : label)))))));
    };
    return Input;
}(React.Component));
export { Input };
var styles = StyleSheet.create({
    text: {
        'box-sizing': 'border-box',
        'width': '100%',
        'outline': 'none',
        'padding': '24px 24px 10px',
        '-webkit-appearance': 'none',
        'transition': 'ease 0.2s border',
        'border-radius': '3px',
        'color': '#5E5E5E',
        'border': '1px solid #D6D6D6',
        'fontSize': '16px',
        'fontWeight': 300,
    },
    showPassword: {
        'position': 'absolute',
        'right': '16px',
        'top': '50%',
        '-webkit-transform': 'translateY(-50%)',
        '-ms-transform': 'translateY(-50%)',
        'transform': 'translateY(-50%)',
        'width': '20px',
        'height': '16px',
        'cursor': 'pointer',
    },
    eye: {
        marginLeft: '1px',
    },
    textPseudo: {
        ':hover': {
            border: 'solid 1px #1a66ff',
            outline: 'none',
        },
        ':focus': {
            border: 'solid 1px #1a66ff',
            outline: 'none',
        },
        ':disabled': {
            border: 'solid 1px #1a66ff',
            cursor: 'not-allowed',
            outline: 'none',
        },
        '::placeholder': {
            color: '#D6D6D6',
        }
    },
    inputPlaceholder: {
        'position': 'absolute',
        'pointer-events': 'none',
        'text-align': 'left',
        'width': 'calc(100% - 64px)',
        'transition': '0.2s ease all',
        'transform': 'translateY(-50%)',
        'user-select': 'none',
        'font-size': '16px',
        'color': '#D6D6D6',
        'top': '28px',
        'left': '20px',
    },
    inputPlaceholderWrapper: {
        position: 'relative',
        width: '100%',
        height: '56px',
        fontWeight: 300,
    },
    inputPlaceholderFocused: {
        'font-size': '12px',
        'top': '13px',
        'left': '24px',
    },
    inputPlaceholderError: {
        color: 'red',
    },
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/ecommscript-integrationappauth/dist/CommonUI/Controls/Input.js
// module id = 1256
// module chunks = 0